document.addEventListener('DOMContentLoaded', function () { 
  const accordionQuestions = document.querySelectorAll('.accordion-question');
  accordionQuestions.forEach((question) => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isActive = question.classList.contains('active');
      accordionQuestions.forEach((q) => {
        if (q !== question) {
          q.classList.remove('active');
          q.nextElementSibling.classList.remove('active');
        }
      });
      question.classList.toggle('active');
      answer.classList.toggle('active');
    });
  });
});
